export default __webpack_public_path__ + "static/media/sep2023-3.e2e6e695.jpg";